import { ICellRendererParams } from 'ag-grid-community'
import { StatusComboBox } from '../../../../../view/components/comboBox/StatusComboBox'
import { ProgressIcon } from '../../../commons/AgGrid/components/cell/custom/wbsItemStatus/ProgressIcon'
import { styled, Box, IconButton } from '@mui/material'
import { RootDiv } from '../../../commons/AgGrid/components/cell/CellRendererRoot'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import { colorPalette } from '../../../../style/colorPalette'
import { FontSize } from '../../../../../styles/commonStyles'
import { WbsItemSearchRow } from '../../../../pages/WbsItemSearch/wbsItemSearchOptions'

export const StatusRootDiv = styled(RootDiv)({
  '&.sevend-ag-cell': {
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    gap: '4px',
  },
})

const StatusComboBoxContainer = styled(Box)({
  flex: 1,
  minWidth: 0,
})

export const ProgressIconArea = styled('span')({
  width: 20,
  display: 'flex',
  justifyContent: 'center',
  flexShrink: 0,
})

const StyledIconButton = styled(IconButton)({
  padding: '2px',
})

const StyledMoreVertIcon = styled(MoreVertRoundedIcon)({
  color: colorPalette.monotone[4],
  fontSize: FontSize.MEDIUM,
  '&:hover': {
    color: colorPalette.monotone[6],
  },
})

export const WbsItemStatusCellRenderer = (
  params: ICellRendererParams & {
    onMoreOptionsClick?: (
      target: EventTarget | undefined,
      row: WbsItemSearchRow | undefined
    ) => void
  }
) => {
  const { value, data, api, node, colDef } = params
  const wbsItem = data?.task ?? data?.body?.wbsItem ?? data?.wbsItem

  if (!wbsItem) {
    return <></>
  }

  const handleMoreOptionsClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!params.onMoreOptionsClick) return
    params.onMoreOptionsClick(event.target, data)
  }

  return (
    <StatusRootDiv>
      <ProgressIconArea>
        <ProgressIcon wbsItem={wbsItem} fontSize={20} />
      </ProgressIconArea>
      <StatusComboBoxContainer>
        <StatusComboBox
          value={value}
          options={[]}
          dropDownListOpen={false}
          onClick={() => {
            api.startEditingCell({
              rowIndex: node.rowIndex ?? 0,
              colKey: colDef?.colId ?? colDef?.field ?? '',
            })
          }}
        />
      </StatusComboBoxContainer>
      <StyledIconButton onClick={handleMoreOptionsClick}>
        <StyledMoreVertIcon className="sevend-ag-cell-status__status-change-popper-trigger" />
      </StyledIconButton>
    </StatusRootDiv>
  )
}
